import { useEffect, useState } from "react";
import { IStaffEmployeeTraining } from "../../../../../models/staff/employeeTraining";
import { ITrainingBlocks } from "../../../../../models/master/training";
import { connect, useDispatch } from "react-redux";
import { pageBlockId } from "../../../../../constants/pageBlocks";
import { setTrainigBlocks } from "../../../../../store/slices/master/trainingBlockSlice";
import { getTrainingBlocks, updateTrainingRegisterAndAttend } from "../../../../../action/masters/trainingActionCreator";
import { baseURL } from "../../../../../constants/commonConstants";
import ReactModal from "react-modal";
import TrainingDetails from "../employeeTrainingModal/trainingDetails";
import { format } from "date-fns";

const EmployeeTrainingViewAll = (props: IStaffEmployeeTraining) => {
  const { getTrainingBlocks, trainingBlocks, updateTrainingRegisterAndAttend } = props;
  const [showDetail, setShowDetail] = useState(false);
  const [trainingDetail, setTrainingDetail] = useState<ITrainingBlocks | undefined>(undefined);
  const dispatch = useDispatch();

  useEffect(() => {
    getTrainingBlocks(pageBlockId.trainingBlocks, undefined);
  }, []);

  const findCourseDetail = (id: number | null) => {
    setTrainingDetail(
      trainingBlocks?.find((trainingBlock: any) => trainingBlock.id === id)
    );
  };

  const handleShow = () => setShowDetail(true);

  const handleClose = () => setShowDetail(false);

  const trainingRegisterOrAttend = async (id: number, link: string) => {
    const validUrl = /^(http|https):\/\//.test(link)
      ? link
      : `https://${link}`;
    window.open(validUrl, '_blank');
    await updateTrainingRegisterAndAttend(id);
    getTrainingBlocks(pageBlockId.trainingBlocks, undefined);
  }

  useEffect(() => {
    return () => {
      dispatch(setTrainigBlocks([]));
    };
  }, []);

  return (
    <>
      <div className="widgets">
        <div className="title">
          <h2>All Employee Training</h2>
        </div>
        <div className="card-wrap">
          <div className="row training-all-wrap">
            {trainingBlocks?.filter((trainingblockitem: ITrainingBlocks) => !trainingblockitem.isCompleted).map((trainingblockitem: ITrainingBlocks) => (
              <div className="col-lg-6 mb-3">
                <div className="training-card">
                  <div className="trainingdtls">
                    <div className="img">
                      <img src={baseURL + trainingblockitem.image} alt="" />
                    </div>
                    <div className="desc">
                      <h6>{trainingblockitem.trainingCategory}</h6>
                      <p className="fw-semibold">{trainingblockitem.name}</p>
                      <p className="para-hide-2">{trainingblockitem.description}</p>
                      <p>
                        {trainingblockitem.trainingDate && format(trainingblockitem.trainingDate, "MM-dd-yyyy")}
                        {trainingblockitem.endDate && ` - ${format(trainingblockitem.endDate, "MM-dd-yyyy")}`}
                      </p>
                    </div>
                  </div>

                  <div className="btn-flex justify-content-between mt-2 border-top">
                    <div className="btn-flex justify-content-start gap-1">
                      <button
                        type="button"
                        className={
                          trainingblockitem.isMandatory
                            ? "btn-icon-border btn-tooltip tran-mandaroty active"
                            : "btn-icon-border btn-tooltip tran-mandaroty"
                        }
                        data-tooltip="Mandatory Training"
                        data-tooltip-pos="up"
                      >
                        <span>
                          <i className="fa-solid fa-star"></i>
                        </span>
                      </button>
                      <button
                        type="button"
                        className={
                          trainingblockitem.isAttendInPerson
                            ? "btn-icon-border btn-tooltip tran-inperson active"
                            : "btn-icon-border btn-tooltip tran-inperson"
                        }
                        data-tooltip="In-Person Training"
                        data-tooltip-pos="up"
                      >
                        <span>
                          <i className="fa-solid fa-user"></i>
                        </span>
                      </button>
                      <button
                        type="button"
                        className={
                          trainingblockitem.isOnline
                            ? "btn-icon-border btn-tooltip tran-online active"
                            : "btn-icon-border btn-tooltip tran-online"
                        }
                        data-tooltip="Online Training"
                        data-tooltip-pos="up"
                      >
                        <i className="fa-solid fa-desktop"></i>
                      </button>
                    </div>
                    <div className="btn-flex justify-content-end gap-2">
                      {trainingblockitem.isRegistered ? (
                        <button className="btn btn-small btn-danger" onClick={() => trainingRegisterOrAttend(trainingblockitem.id, trainingblockitem.linkToAttendTraining)}>
                          Attend
                        </button>
                      ) : (
                        <button className="btn btn-small btn-primary" onClick={() => trainingRegisterOrAttend(trainingblockitem.id, trainingblockitem.linkToRegister)}>
                          Register
                        </button>
                      )}

                      <button
                        className="btn btn-small btn-secondary"
                        data-bs-toggle="modal"
                        data-bs-target="#training-details"
                        onClick={() => {
                          handleShow();
                          findCourseDetail(trainingblockitem.id);
                        }}
                      >
                        View More
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        <ReactModal
          isOpen={showDetail}
          onRequestClose={handleClose}
          className="react-modal-content"
          overlayClassName="react-modal-overlay"
        >
          <TrainingDetails
            setShowEmployeeTraining={handleClose}
            trainingHelp={trainingDetail}
          />
        </ReactModal>
      </div>
    </>
  );
};

const mapDispatchToProps = {
  getTrainingBlocks: (pageBlockId?: number, noOfItems?: number) =>
    getTrainingBlocks(pageBlockId, noOfItems),
  updateTrainingRegisterAndAttend: (id: number) => updateTrainingRegisterAndAttend(id)
};

function mapStateToProps(state: any) {
  return {
    trainingBlocks: state.trainingBlock.trainingBlocks,
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EmployeeTrainingViewAll);
